interface NativeBridges {
  ReactNativeWebView?: { postMessage: (message: string) => void };
  webkit?: { messageHandlers?: Record<string, { postMessage: (message: unknown) => void }> };
}

const IOS_HANDLER = 'protectorBridge';

const getNativeBridges = (): NativeBridges | undefined => {
  if (typeof window === 'undefined') return undefined;
  return window as Window & NativeBridges;
};

export const hasDirectNavigationTransport = (): boolean => {
  const bridges = getNativeBridges();
  return Boolean(bridges?.ReactNativeWebView?.postMessage || bridges?.webkit?.messageHandlers?.[IOS_HANDLER]?.postMessage);
};

export const emitNativeNavigation = (payload: object): void => {
  const bridges = getNativeBridges();
  if (!bridges) return;

  bridges.ReactNativeWebView?.postMessage(JSON.stringify(payload));
  bridges.webkit?.messageHandlers?.[IOS_HANDLER]?.postMessage(payload);
};
